import { combineReducers } from 'redux';
import 'formdata-polyfill';
import {
  BACK_INPUT_PAGE, CLEAR_FORM, RECEIVE_CONFIRM, SET_FORM,
  FINISH_CONTACT, REQUEST_CONTACT, REQUEST_CONFIRM,
  ERROR_GENERATED, FORM_INIT
} from '../actions';
import initialState from './initial_state';

const form = (state = {}, action) => {
  const object = {};
  switch (action.type) {
    case SET_FORM:
      (new FormData(action.form)).forEach((value, key) => {
        object[key] = value;
      });
      return object;
    case CLEAR_FORM:
    case FINISH_CONTACT:
      for (const key in state) {
        if (Object.prototype.hasOwnProperty.call(state, key)) {
          object[key] = '';
        }
      }
      return object;
    default:
      return state;
  }
};

const inputPage = (state = {}, action) => {
  switch (action.type) {
    case BACK_INPUT_PAGE:
    case FORM_INIT:
      return true;
    case RECEIVE_CONFIRM:
      return !action.status;
    case ERROR_GENERATED:
      return false;
    default:
      return state;
  }
};

const confirmPage = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_CONFIRM:
      return action.status;
    case BACK_INPUT_PAGE:
      return false;
    case ERROR_GENERATED:
    case FINISH_CONTACT:
      return false;
    default:
      return state;
  }
};

const resultPage = (state = {}, action) => {
  switch (action.type) {
    case FINISH_CONTACT:
      return true;
    case ERROR_GENERATED:
      return false;
    default:
      return state;
  }
};

const errorPage = (state = false, action) => {
  switch (action.type) {
    case ERROR_GENERATED:
      return true;
    default:
      return state;
  }
};

const isRequesting = (state = false, action) => {
  switch (action.type) {
    case REQUEST_CONTACT:
    case REQUEST_CONFIRM:
    case FINISH_CONTACT:
    case BACK_INPUT_PAGE:
    case RECEIVE_CONFIRM:
      return action.request;
    case FORM_INIT:
      return false;
    default:
      return state;
  }
};

const validationErrors = (state = {}, action) => {
  const object = {};
  switch (action.type) {
    case FORM_INIT:
      const errors = {};
      action.form_settings.fields.forEach(field => {
        errors[field.key] = '';
      });
      return errors;
    case CLEAR_FORM:
      for (const key in state) {
        if (Object.prototype.hasOwnProperty.call(state, key)) {
          object[key] = '';
        }
      }
      return object;
    case RECEIVE_CONFIRM:
      return action.errors;
    default:
      return state;
  }
};

const validateError = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_CONFIRM:
      return !action.status;
    case CLEAR_FORM:
      return false;
    default:
      return state;
  }
};

const token = (state = '', action) => {
  switch (action.type) {
    case RECEIVE_CONFIRM:
      return action.token;
    default:
      return state;
  }
};

const formSettings = (state = initialState.form_settings, action) => {
  switch (action.type) {
    case FORM_INIT:
      return action.form_settings;
    default:
      return state;
  }
}

export default combineReducers({
  form,
  input_page: inputPage,
  confirm_page: confirmPage,
  result_page: resultPage,
  error_page: errorPage,
  isRequesting,
  validationErrors,
  validateError,
  token,
  form_settings: formSettings
});
